var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "#6C6C6C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.29289,0l6.70711,0l0,9.5l-1,0l0,-8.5l-5.29289,0l-4.70711,4.7071l0,9.2929l2,0l0,1l-3,0l0,-10.7071l5.29289,-5.2929z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5,5l0,-4l1,0l0,5l-5,0l0,-1l4,0z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.0196,16.97245c0,0.5523 0.448,1 1,1c0.552,0 1,-0.4477 1,-1c0,-0.5523 -0.448,-1 -1,-1c-0.552,0 -1,0.4477 -1,1zm1,-2c-1.105,0 -2,0.8954 -2,2c0,1.1046 0.895,2 2,2c1.105,0 2,-0.8954 2,-2c0,-1.1046 -0.895,-2 -2,-2z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3576,14.97235l0.662,0.6416l-2.493,2.3585l-1.507,-1.4459l0.665,-0.6383l0.846,0.8107l1.827,-1.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0196,11.97245c0,0.5523 0.448,1 1,1c0.552,0 1,-0.4477 1,-1c0,-0.5523 -0.448,-1 -1,-1c-0.552,0 -1,0.4477 -1,1zm1,-2c-1.105,0 -2,0.8954 -2,2c0,1.1046 0.895,2 2,2c1.105,0 2,-0.8954 2,-2c0,-1.1046 -0.895,-2 -2,-2z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3576,9.97235l0.662,0.6416l-2.493,2.3585l-1.507,-1.4459l0.665,-0.6383l0.846,0.8107l1.827,-1.7266z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/TaskIcon.ee75dd8275d6dd5ce3c06aa6078fe2e3.svg";
export { ForwardRef as ReactComponent };